module.exports = __webpack_public_path__ + "img/chadle1_4.4853d823.png";